import { Flex, theme } from '@/components';
import {
  type ProjectSearchFormType,
  ProjectSearchKeys,
} from '@/features/search/_models/projects-search';
import { PROJECT_SEARCH_TAG_TEST_ID } from '@/features/search/_utils/projects-search';
import type { ExtractKeyOf } from '@/utils/utils';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CascaderFieldTag } from '../_common/tags/CascaderFieldTag';
import { PaymentTag } from '../_common/tags/PaymentTag';
import { TextSearchTag } from '../_common/tags/TextSearchTag';
import { CommonFilterTag } from './CommonFilterTag';
import { AmountSearchTypeTag } from './tags/AmountSearchTypeTag';

type FieldKey = (typeof ProjectSearchKeys)[number];

type HiddenFieldKey = ExtractKeyOf<
  FieldKey,
  | 'nestedOtherResponsibleOrganizationIds'
  | 'nestedPolicyIds'
  | 'nestedExpenditureBudgetPurposeIds'
  | 'nestedOrganizationIds'
>;

const cascaderFildsKeys: HiddenFieldKey[] = [
  'nestedOrganizationIds',
  'nestedPolicyIds',
  'nestedOtherResponsibleOrganizationIds',
  'nestedExpenditureBudgetPurposeIds',
];

export const ProjectsSearchFieldTags: FC<{
  onResetPayment: () => void;
}> = ({ onResetPayment }) => {
  const { token } = theme.useToken();
  const { control } = useFormContext<ProjectSearchFormType>();
  const amountSearchConditions = useWatch({
    control,
    name: 'amountSearchConditions',
  });

  return (
    <Flex vertical gap={8} wrap="wrap" data-testid={PROJECT_SEARCH_TAG_TEST_ID}>
      <Flex
        gap={8}
        style={{ background: token.colorBgLayout, padding: 5 }}
        wrap="wrap"
      >
        {ProjectSearchKeys.map((field) => {
          switch (field) {
            // case 'fundSheetType':
            //   return <FundSheetTypeTag key={field} />;
            case 'q':
              return <TextSearchTag key={field} />;
            case 'corporateNumber':
              return <PaymentTag key={field} onResetPayment={onResetPayment} />;
            // case 'categories':
            //   return <CategoriesTag key={field} />;
            // case 'implementationMethods':
            //   return <ImplementationMethodsTag key={field} />;
            // case 'accountingType':
            //   return <AccountingTypeTag key={field} />;
            // case 'accountingTypeIds':
            //   return <AccountingTypeIdsTag key={field} />;
            // case 'skipAdministrativeReformTeamEvaluation':
            case 'sheetType':
              return null;
            // case 'isPublished':
            //   return <IsPublishedTag key={field} />;
            // case 'period':
            //   return <PeriodTag key={field} />;
            // case 'inspectionByExternalExpertReviewType':
            //   return <InspectionByExternalExpertReviewTypeTag key={field} />;
            // case 'lastImplementedFiscalYearPeriod':
            //   return <LastImplementedFiscalYearPeriodTag key={field} />;
            // case 'isCandidateOfInspectionByExternalExpert':
            //   return <IsCandidateOfInspectionByExternalExpertTag key={field} />;
            default:
              return <CommonFilterTag key={field} field={field} />;
          }
        })}
        {/* amountSearchConditions の各要素に対してタグを表示 */}
        {amountSearchConditions?.map((_, index) => (
          <AmountSearchTypeTag
            key={`amountSearchConditions-${
              // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
              index
            }`}
            index={index}
          />
        ))}
      </Flex>
      {cascaderFildsKeys.map((field) => (
        <CascaderFieldTag key={field} field={field} />
      ))}
    </Flex>
  );
};
